import colors from '../../../public/colors'


const styles = theme => {
    const { mode } = theme.palette
    return {
        centralLanguageButton: {
            background: 'white',
            boxShadow: 'none',
            color: 'rgb(0, 81, 165)',
            float: 'right',
            fontSize: '10px',
            margin: '10px'
        },
        doneMenuIcon: {
            height: '19px',
            paddingBottom: '2px',
            paddingLeft: '4px',
            width: '19px'
        },
        languageButton: {
            boxShadow: 'none',
            color: 'rgb(0, 81, 165)',
            float: 'right',
            margin: '10px',
            width: '120px'
        },
        languageButtonLogin: {
            '&:hover': {
                boxShadow: 'none',
            },
            boxShadow: 'none',
            color: 'white',
            float: 'right',
            margin: '10px',
            width: '120px'
        },
        languageButtonLoginMain: {
            '&:hover': {
                boxShadow: 'none',
            },
            backgroundColor: 'unset',
            boxShadow: 'none',
            color: 'white',
            float: 'right',
            margin: '10px',
            width: '120px'
        },
        languageMenu: {
            background: colors[mode].primaryBackground,
            border: `1px solid ${colors[mode].headerBorder}`,
            borderRadius: '2px',
            boxShadow: 'none',
            height: '110px',
            marginLeft: '-127px',
            marginTop: '12px',
            width: '155px'
        },
        languageMenuDefaultRegister: {
            '@media screen and (max-width: 767px)': {
                marginLeft: '-90px'
            },
            marginLeft: '-113px'
        },
        languageMenuBox: {
            alignItems: 'center',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            marginTop: '7px'
        },
        languageMenuIcon: {
            color: colors[mode].primaryText,
            height: '19px',
            width: '19px',
        },
        languageMenuIconSub: {
            height: '19px',
            width: '19px',
        },
        languageMenuItem: {
            alignItem: 'center',
            display: 'flex',
            justifyContent: 'center',
            marginRight: '35px'
        },
        languageMenuItems: {
            '&:hover': {
                background: colors[mode].languageHoverBackground,
            },
            '&:hover $DoneMenuIcon': {
                color: colors[theme.palette.mode].moveToTop
            },
            borderRadius: '2px',
            color: colors[mode].primaryText,
            display: 'flex',
            flexDirection: 'row',
            height: '43px',
            justifyContent: 'flex-start',
            width: '140px'
        },
        languageMenuItemsActive: {
            '&:hover': {
                background: colors[mode].languageHoverBackground,
            },
            borderRadius: '2px',
            color: colors[mode].languageActive,
            display: 'flex',
            flexDirection: 'row',
            height: '43px',
            justifyContent: 'flex-start',
            width: '140px'
        },
        languageMenuText: {
            fontFamily: 'Roboto',
            fontSize: '14px',
            fontWeight: 400,
            marginLeft: '10px'
        },
        mobileLanguageButton: {
            '@media screen and (min-width: 767px)': {
                display: 'none'
            },
            color: 'rgb(0, 81, 165)',
            float: 'right',
            fontSize: '10px',
            marginLeft: '65%',
            width: '35%'
        },
        mobileLanguageButtonCustom: {
            '@media screen and (max-width: 395px)': {
                marginLeft: '115px'
            },
            '@media screen and (min-width: 767px)': {
                display: 'none'
            },
            color: 'rgb(0, 81, 165)',
            float: 'right',
            fontSize: '10px',
            marginLeft: '155px',
            width: '35%'
        },
        mobileLanguageButtonCustomFr: {
            '@media screen and (max-width: 395px)': {
                marginLeft: '90px'
            },
            '@media screen and (min-width: 767px)': {
                display: 'none'
            },
            color: 'rgb(0, 81, 165)',
            float: 'right',
            fontSize: '10px',
            marginLeft: '130px',
            width: '35%'
        },
        mobileLanguageButtonDefault: {
            '@media screen and (min-width: 767px)': {
                display: 'none'
            },
            color: 'rgba(0, 49, 104, 0.9)',
            float: 'right',
            fontSize: '12px',
            fontWeight: '400',
            width: '35%'
        },
        mobileLanguageButtonRegister: {
            '@media screen and (min-width: 767px)': {
                display: 'none'
            },
            color: 'rgb(0, 81, 165)',
            float: 'right',
            fontSize: '10px',
            width: '35%'
        }
    }
}

export default styles
